module.exports = __webpack_public_path__ + "img/ImgCloseIcon.69f6bfc3.svg";